import React from 'react';
import { Link } from 'react-router-dom';
import withUser from '../common/withUser';
import Notification from '../components/Header/Notification';
import UserSideBarMenu from '../components/Header/UserSideBarMenu';
import styles from './Header.module.css';
import supportTicket from '../assets/images/supportTicket.jpg';
import logo from '../assets/images/logo.png';

function Header(props) {
  const { categoryData, user, unreadCount } = props;
  return (
    <header className="header-fixd-con">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link to={user.view?.id !== 1 ? `/category/${categoryData[0]?.name}/${categoryData[0]?.id}` : '/startups'}>
            <img
              src={logo}
              alt=""
              height="100"
              className={styles['ciie-logo']}
            />
          </Link>
          <div className={styles['header-list-con']}>
            <ul>
              <li>{user.view?.id !== 1 ? <Notification unreadCount={unreadCount} user={user} /> : ''}</li>
              <li>
                {user.view?.id !== 1 ? (
                  <Link
                    title="Request for new Service Partners"
                    to="/request-support"
                  >
                    <img height="35px" src={supportTicket} alt="support" />
                  </Link>
                ) : (
                  ''
                )}
              </li>
              <li>
                <UserSideBarMenu user={user} />
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default withUser(Header);
